import { render, staticRenderFns } from "./activityGoodsStock.vue?vue&type=template&id=8251e4cc&"
import script from "./activityGoodsStock.vue?vue&type=script&lang=js&"
export * from "./activityGoodsStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports